<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="套餐名称"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.level"
        placeholder="套餐等级"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.image"
            :src="scope.row.image"
            class="plan-thumb"
            alt="plan"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="等级" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.level }}
        </template>
      </el-table-column>
      <el-table-column label="价格" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column label="总量" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_supply }}
        </template>
      </el-table-column>
      <el-table-column label="已售" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.sold_count || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="推荐奖励比例" width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.refer_reward_rate }}
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="200">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.description"
            effect="dark"
            :content="scope.row.description"
            placement="top"
          >
            <span class="desc-text">{{ scope.row.description }}</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openEdit(scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="编辑套餐"
      :visible.sync="editDialogVisible"
      width="600px"
      @closed="resetEditForm"
    >
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="editForm.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="图片">
          <el-input v-model="editForm.image" placeholder="图片URL" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="editForm.description"
            type="textarea"
            :rows="3"
            placeholder="描述"
          />
        </el-form-item>
        <el-form-item label="等级">
          <el-input-number
            v-model="editForm.level"
            :min="0"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="editForm.price" placeholder="价格" />
        </el-form-item>
        <el-form-item label="总量">
          <el-input-number
            v-model="editForm.total_supply"
            :min="0"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="推荐奖励比例">
          <el-input
            v-model="editForm.refer_reward_rate"
            placeholder="请输入比例，如 0.1"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editLoading" @click="submitEdit">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

const emptyEditForm = () => ({
  id: null,
  name: "",
  image: "",
  description: "",
  level: 0,
  price: "",
  total_supply: 0,
  refer_reward_rate: "",
});

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        level: "",
      },
      editDialogVisible: false,
      editForm: emptyEditForm(),
      editLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      const params = { ...this.listQuery };
      if (!params.name) {
        delete params.name;
      }
      if (params.level === "" || params.level === null || params.level === undefined) {
        delete params.level;
      }
      request({
        url: "/api/admin/nft-plan/list",
        method: "get",
        params,
      })
        .then((res) => {
          this.list = res.data?.data || [];
          this.total = res.data?.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        name: row.name,
        image: row.image,
        description: row.description,
        level: Number(row.level || 0),
        price: row.price,
        total_supply: Number(row.total_supply || 0),
        refer_reward_rate: row.refer_reward_rate ?? "",
      };
      this.editDialogVisible = true;
    },
    resetEditForm() {
      this.editForm = emptyEditForm();
      this.editLoading = false;
    },
    submitEdit() {
      if (!this.editForm.id) {
        this.$message.error("缺少套餐ID");
        return;
      }
      this.editLoading = true;
      request({
        url: "/api/admin/nft-plan/update",
        method: "post",
        data: this.editForm,
      })
        .then(() => {
          this.$message.success("更新成功");
          this.editDialogVisible = false;
          this.getList();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.plan-thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}
.desc-text {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
